module.exports = __webpack_public_path__ + "static/media/think2.e511e173.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/think2.png
// module id = 327
// module chunks = 0